import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {URLS} from "../../apiService";

const MicrosoftCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get("email");
        const name = params.get("name");

        if (!email) {
            navigate("/login");
            return;
        }

        fetch(`${URLS.user}/auth/microsoft/sso-login`, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify({email, name}),
        })
            .then(res => res.json())
            .then(data => {
                const token = data?.data?.token;
                const user = data?.data?.user;

                if (!token || !user) {
                    navigate("/login");
                    return;
                }

                localStorage.setItem("authToken", token);
                localStorage.setItem("user", JSON.stringify(user));

                navigate("/dashboard", {replace: true});
            })
            .catch(() => navigate("/login"));
    }, [navigate]);

    return <h3>Logging in with Microsoft…</h3>;
};

export default MicrosoftCallback;
